import { render, staticRenderFns } from "./baidumap.vue?vue&type=template&id=8e522a1c"
import script from "./baidumap.vue?vue&type=script&lang=js"
export * from "./baidumap.vue?vue&type=script&lang=js"
import style0 from "./baidumap.vue?vue&type=style&index=0&id=8e522a1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports